import Vue from 'vue'
import Seb from '@/shared/application/seb'
import { Component } from 'vue-property-decorator'

@Component
export default class SebStringTools extends Vue {
  protected seb = Seb

  public static getTrigram (userName: any) {
    return userName.substring(0, 3).toUpperCase()
  }

  public static convertISODateToString (dStr: string) {
    const d = new Date(dStr)
    const year = d.getFullYear().toString()

    const dMonthString = (d.getMonth() + 1).toString()
    const month = dMonthString.length === 2 ? dMonthString : '0' + dMonthString

    const day = d.getDate().toString().length === 2 ? d.getDate().toString() : '0' + d.getDate().toString()

    const hour = d.getHours().toString().length === 2 ? d.getHours().toString() : '0' + d.getHours().toString()

    const dMinutesString = ((d.getMinutes() / 5) * 5).toString()
    const minute = dMinutesString.length === 2 ? dMinutesString : '0' + dMinutesString

    const dSecondsString = ((d.getSeconds() / 5) * 5).toString()
    const second = dSecondsString.length === 2 ? dSecondsString : '0' + dSecondsString
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`
  }

  public static convertModelToQueryString (params: any): string {
    return Object.keys(params)
      .map((key) => {
        if (Array.isArray(params[key])) {
          let temp = ''
          params[key].forEach((e: string) => {
            temp += key + '=' + e + '&'
          })
          return temp.slice(0, -1).replace(/$/, '')
        } else {
          return key + '=' + params[key]
        }
      })
      .join('&')
  }

  public static copyToClipboard (text: string) {
    const dummy = document.createElement('textarea')
    document.body.appendChild(dummy)
    // Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
    dummy.value = text
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
  }
}
